{
    "previous": "Предыдущая",
    "next": "Следующая",
    "go5back": "Назад на 5 страниц",
    "go5next": "Вперед на 5 страниц",
    "items": "элементов",
    "itemsPerPage": "элементов на страницу"
}
